import {Component, Input, OnDestroy} from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import { Application, GetHistoricalContractsFn, HistoricalContract } from '@portal-workspace/grow-shared-library';
import { FlexModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { loadingFor } from '@ngneat/loadoff';
import { AsyncPipe } from '@angular/common';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';

@Component({
    selector: 'credit-result-historical-contracts',
    templateUrl: './credit-result-historical-contracts.component.html',
    styleUrls: ['./credit-result-historical-contracts.component.scss'],
    standalone: true,
    imports: [
      MatTableModule, 
      NgClass, 
      ExtendedModule, 
      FlexModule,
      AsyncPipe,
      MessageBoxComponent,
      LooseCurrencyPipe,
    ]
})
export class CreditResultHistoricalContractsComponent implements OnDestroy {
  @Input({required: true}) application!: Application;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  subscriptions: Subscription[] = [];
  loader = loadingFor('tableLoading');
  dataSource: HistoricalContract[] = [];
  columnsToDisplay = ['EntityName', 'FiscalContractCode', 'WDV', 'tenure', 'DishonourCount', 'DishonourCountL12m', 'arrears60dplus', 'WorstArrearsL12m', 'WOFF_flag'];
  totalWDV = 0;
  hasError = false;
  dataLoaded = false;

  constructor(
    private toastService: PortalHotToastService,
  ) {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  loadContracts() {
    if (this.dataLoaded) {
      return; // Prevent reloading
    }
    this.dataLoaded = true;
    this.hasError = false;
    this.dataSource = [];
    this.subscriptions.push(
      this.getHistoricalContractsFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable()
      ).subscribe({
        next: (contracts: HistoricalContract[]) => {
          this.dataSource = contracts;
          this.totalWDV = contracts.reduce((sum, c) => sum + (typeof c.WDV === 'number' ? c.WDV : 0), 0);
        },
        error: (error) => {
          console.error('Error loading historical contracts:', error);
          this.hasError = true;
          this.dataSource = [];
          this.totalWDV = 0;
        }
      })
    );
  }

  getColumnTitle(column: string): string {
    switch(column) {
      case 'EntityName': return 'Entity Name';
      case 'FiscalContractCode': return 'Contract Code';
      case 'tenure': return 'Tenure';
      case 'arrears60dplus': return 'Arrears 60d+';
      case 'WDV': return 'WDV';
      case 'WOFF_flag': return 'Written Off';
      case 'WorstArrearsL12m': return 'Worst Arrears L12m';
      case 'DishonourCount': return 'Count of Dishonours';
      case 'DishonourCountL12m': return 'Count of Dishonours L12m';
      default: return column;
    }
  }

  formatValue(value: unknown, column?: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (column === 'WOFF_flag' && typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (typeof value === 'number') {
      return value.toString();
    }
    return String(value);
  }
}

